import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <i className="ri-map-pin-line text-4xl text-foreground-300"></i>
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mt-6">
          這個頁面尚未抵達
        </h2>
        <p className="mt-2 text-sm text-foreground-400 font-mono">
          {location.pathname}
        </p>
        <p className="mt-4 text-base text-foreground-500">
          未境原創的網站結構已更新，請回到首頁或聯繫崧博出版
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <Link
            to="/"
            className="px-6 py-3 text-sm font-label bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            返回首頁
          </Link>
          <a
            href="https://sonbook.net"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="px-6 py-3 text-sm font-label bg-secondary-500 text-white rounded-full hover:bg-secondary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            前往崧博出版
          </a>
        </div>
      </div>
    </div>
  );
}